 /*
 *
 *  actions
 *
 */


import {
  //LOAD_MAGAZINE_TEAM
  LOAD_MAGAZINE_TEAM,
  LOAD_MAGAZINE_TEAM_SUCCESS,
  LOAD_MAGAZINE_TEAM_ERROR,


  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

 

 
} from "./constants"

export function loadRecordsCacheHit() {
  return {
   // type: LOAD_RECORDS_VALID_CACHE  videoTeam_data
  }
}

//loadMagazineTeamDetails
export function loadMagazineTeamDetails(searchFilter) {
  return {
    type: LOAD_MAGAZINE_TEAM,
    searchFilter,
  }
}


export function loadMagazineTeamDetailsSuccess(magazineTeam_data, success) {
  return {
    type: LOAD_MAGAZINE_TEAM_SUCCESS,
    magazineTeam_data,
    success,
  }
}


export function loadMagazineTeamDetailsError(error) {
  return {
    type: LOAD_MAGAZINE_TEAM_ERROR,
    error,
  }
}



export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

const actions = {
  loadMagazineTeamDetails,
  loadMagazineTeamDetailsSuccess,
  loadMagazineTeamDetailsError,


  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

}

export default actions
